<div class="h-full" [class.script-mobile]="mediaQueryService.isMobile$ | async"
  [class.script-desktop-sm]="mediaQueryService.isDesktopSm$ | async"
  [class.script-desktop-lg]="mediaQueryService.isDesktopLg$ | async"
  [class.script-desktop-xl]="mediaQueryService.isDesktopXl$ | async"
  [class.script-desktop-2xl]="mediaQueryService.isDesktop2Xl$ | async"
  [class.script-desktop-3xl]="mediaQueryService.isDesktop3Xl$ | async"
  [class.script-desktop-4xl]="mediaQueryService.isDesktop4Xl$ | async">
  @if (currentItinerary && (mode === 'embed' || (mode === 'popup' &&
  isCssReady))) {

  <div *ngIf="mode === 'popup'" (click)="backToList()" class="fixed top-0 left-8 z-20 w-full">
    <div #backToListBtn [class.hidden]="isMobile && isMovieSimulateTourShowing"
      class="mt-3 text-gray-300 text-2xl cursor-pointer w-[400px] flex items-center gap-1.5 hover:scale-[1.05] transition-all">
      <img src="https://iti-images.s3.amazonaws.com/imgs/back-arrow.png" class="mr-2" alt="" width="50px" />
      Back to all itineraries
    </div>
  </div>

  <div class="w-full top-40 fixed z-[3001] flex justify-center">
    <ig-confirm-dialog *ngIf="isShowNotSaveConfirm" class="bottom-11 w-[220px]" (confirm)="proceedClose()"
      (cancel)="isShowNotSaveConfirm = false" igClickStopPropagation
      text="There are unsaved changes. Do you want to discard them?"></ig-confirm-dialog>
  </div>

  <div *ngIf="data.isEditMode && !isMovieSimulateTourShowing"
    class="w-[90vw] max-w-[2000px] bg-[transparent] absolute top-0 z-[3000]">
    <ig-itinerary-details-style-editor [textColor]="styleTextColor"
      class="flex gap-2 items-center absolute top-2 right-[36px] z-[100]" (styleChange)="detailsStyleChanged($event)"
      [currentItinerary]="currentItinerary"></ig-itinerary-details-style-editor>

    <ig-map-style-selector *ngIf="currentItinerary.detailsStyle !== 'map3d'" class="absolute top-2 right-[300px] z-20"
      [textColor]="styleTextColor" [style]="currentItinerary.mapStyle" [currentItinerary]="currentItinerary"
      triggerText="Theme mode"></ig-map-style-selector>
  </div>

  @if (tempDetailsStyle === 'map' || currentItinerary.detailsStyle === 'map') {
  <div
    class="flex h-full overflow-auto absolute z-10 top-0 left-0 bg-[#00000088] text-gray-200 transition-all animate-bottom-up"
    [class.ig-iti-white-map]="currentItinerary.mapStyle === 'light'" [class.rounded-xl]="mode === 'popup' && !isMobile">
    <div class="w-full h-full">
      <div class="ig-iti-map-wrap h-full relative">
        @if (currentItinerary) {
        <div
          class="ig-iti-info flex p-10 items-start flex-col transition-all duration-500 h-[45%] w-[calc(100%-3vw)] text-gray-200 animate-bottom-up !absolute top-16 left-0 z-10 mobile:!p-4 mobile:!rounded-none mobile:h-[100%]"
          [class.!rounded-none]="mode === 'embed'" [class.ig-itinerary-title-fold]="isFoldItineraryTitle"
          [class.!text-gray-600]="currentItinerary.mapStyle === 'light'" [class.ig-trans-more-white]="
            currentItinerary.mapStyle === 'light' && !isFoldItineraryTitle
          " [class.ig-trans-less-white]="
            currentItinerary.mapStyle === 'light' && isFoldItineraryTitle
          " [class.ig-trans-more-dark]="
            currentItinerary.mapStyle === 'dark' && !isFoldItineraryTitle
          " [class.ig-trans-less-dark]="
            currentItinerary.mapStyle === 'dark' && isFoldItineraryTitle
          ">
          <h1 (click)="isFoldItineraryTitle = !isFoldItineraryTitle"
            class="ig-itinerary-title font-bold mb-6 max-w-[80%] cursor-pointer transition-all duration-500 flex items-center gap-2 text-blue-500 text-[20px] xl:text-[22px] 2xl:text-[26px] 3xl:text-[32px] mobile:mb-3">
            {{ currentItinerary.title }}

            <div class="ig-iti-fold text-white cursor-pointer" (click)="isFoldItineraryTitle = !isFoldItineraryTitle"
              [class.!text-gray-600]="currentItinerary.mapStyle === 'light'" igClickStopPropagation>
              <mat-icon *ngIf="!isFoldItineraryTitle" class="!w-8 !h-8 text-3xl text-blue-500"
                matTooltip="Hide itinerary info">expand_more
              </mat-icon>
              <mat-icon *ngIf="isFoldItineraryTitle" class="!w-8 !h-8 text-3xl text-blue-500"
                matTooltip="Show itinerary info">chevron_left
              </mat-icon>
            </div>

            <ig-create-itinerary *ngIf="data.isEditMode" [itinerary]="currentItinerary"
              (onCreateItinerary)="itineraryUpdated($event)" triggerText=""
              igClickStopPropagation></ig-create-itinerary>
          </h1>

          <div class="overflow-y-auto px-0.5">
            <p class="transition-all duration-500 ig-itinerary-des text-[13px] 2xl:text-[14px] 3xl:text-[15px]">
              {{ currentItinerary.description }}
            </p>
            <div
              class="flex gap-6 mt-7 items-center transition-all duration-700 ig-itinerary-data mobile:flex-wrap mobile:gap-2 mobile:mt-3">
              <p
                class="text-[0.8vw] text-center border-l-2 pl-2 flex items-center gap-1 3xl:text-[16px] mobile:text-[14px]">
                <mat-icon class="text-[24px]">room </mat-icon>
                {{ currentItinerary.attractions.length }} stops
              </p>
              <p matTooltip="{{currentItinerary.defaultTravelMode.mode }}"
                class="text-[0.8vw] text-center border-l-2 pl-2 flex items-center gap-1 3xl:text-[16px] mobile:text-[14px]">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="24px" height="24px" viewBox="0,0,256,256">
                  <g fill="#fff" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                    stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
                    font-family="none" font-weight="none" font-size="none" text-anchor="none"
                    style="mix-blend-mode: normal" [class.!stroke-black]="
                      currentItinerary.mapStyle === 'light'
                    ">
                    <g transform="scale(10.66667,10.66667)">
                      <path
                        d="M2,6c0,-2.209 1.791,-4 4,-4c2.209,0 4,1.791 4,4c0,1.782 -2.032,4.326 -3.2,5.64c-0.426,0.479 -1.176,0.479 -1.601,0c-1.167,-1.313 -3.199,-3.858 -3.199,-5.64z"
                        opacity="0.35"></path>
                      <circle cx="6" cy="6" r="1.5"></circle>
                      <path
                        d="M14,16c0,-2.209 1.791,-4 4,-4c2.209,0 4,1.791 4,4c0,1.782 -2.032,4.326 -3.2,5.64c-0.426,0.479 -1.176,0.479 -1.601,0c-1.167,-1.313 -3.199,-3.858 -3.199,-5.64z"
                        opacity="0.35"></path>
                      <circle cx="18" cy="16" r="1.5"></circle>
                      <circle cx="6" cy="15" r="1"></circle>
                      <circle cx="9" cy="19" r="1"></circle>
                      <circle cx="14" cy="21" r="1"></circle>
                    </g>
                  </g>
                </svg>
                {{ tripService.convertToTravelDistance(currentItinerary.distance).all }}
              </p>
              <p matTooltip="{{currentItinerary.defaultTravelMode.mode }}"
                class="text-[0.8vw] text-center border-l-2 pl-2 flex items-center gap-1 3xl:text-[16px] mobile:text-[14px]">
                <mat-icon class="text-[24px]">schedule </mat-icon>
                {{ tripService.convertToTravelTimeText(currentItinerary.travelTime)}}
              </p>

              @for (field of currentItinerary.customFields; let i = $index; track i) {
              <p
                class="text-[0.8vw] text-center border-l-2 flex items-center gap-1 pl-4 3xl:text-[16px] mobile:text-[14px]">
                {{ field.field }}
              </p>
              }
            </div>

            <div
              class="flex gap-4 text-sm text-center transition-all duration-500 text-white my-8 ig-itinerary-operation pl-[1px] pb-[2px] mobile:mt-4 mobile:flex-wrap"
              [class.!text-gray-600]="currentItinerary.mapStyle === 'light'">
              <div
                class="px-4 py-2 border border-gray-300 outline outline-0 outline-offset-1 transition-all rounded-sm flex items-center justify-center cursor-pointer smallDesktop:text-[11px] hover:bg-[#ffffff66] w-[150px]"
                [class.!outline-1]="currentItinerary.mapStyle === 'light'" (click)="exportPDF()">
                <span *ngIf="!isGeneratingPDF">EXPORT AS PDF</span>
                <ig-spinner *ngIf="isGeneratingPDF" [diameter]="20"></ig-spinner>
              </div>
              <div
                class="px-4 py-2 border border-gray-300 outline outline-0 outline-offset-1 transition-all rounded-sm flex items-center justify-center cursor-pointer smallDesktop:text-[11px] hover:bg-[#ffffff66]"
                [class.!outline-1]="currentItinerary.mapStyle === 'light'" (click)="shareItinerary()">
                SHARE ITINERARY
              </div>
              <div
                class="px-4 py-2 border border-gray-300 outline outline-0 outline-offset-1 transition-all rounded-sm flex items-center justify-center cursor-pointer smallDesktop:text-[11px] hover:bg-[#ffffff66]"
                [class.!outline-1]="currentItinerary.mapStyle === 'light'" (click)="movie360()">
                VIRTUAL TOUR
              </div>
              <div
                class="px-4 py-2 relative border border-gray-300 outline outline-0 outline-offset-1 transition-all rounded-sm flex items-center justify-center cursor-pointer smallDesktop:text-[11px] hover:bg-[#ffffff66]"
                [class.!outline-1]="currentItinerary.mapStyle === 'light'" (click)="isShowGPSConfirm=true"
                igOutsideClick (outsideClick)="isShowGPSConfirm = false" igClickStopPropagation>
                GPS DIRECTIONS

                <ig-confirm-dialog *ngIf="isShowGPSConfirm"
                  class="!w-[300px] -right-20 bottom-4 absolute mobile:!w-[191px] mobile:-right-16"
                  (confirm)="gpsDirections()" (cancel)="directions()" [isShowIcon]="false" igClickStopPropagation
                  text="Do you want to start this itinerary from your current location?">
                </ig-confirm-dialog>
              </div>
              <div
                class="px-4 py-2 border border-gray-300 outline outline-0 outline-offset-1 transition-all rounded-sm flex items-center justify-center cursor-pointer smallDesktop:text-[11px] hover:bg-[#ffffff66]"
                [class.!outline-1]="currentItinerary.mapStyle === 'light'" #travelModeMenuTrigger="matMenuTrigger"
                [matMenuTriggerFor]="travelModeMenu" [class.ig-hide]="!currentItinerary.defaultTravelMode.canChange">
                TRAVEL MODE
              </div>
              <mat-menu #travelModeMenu="matMenu" class="ig-iti-details-style-menu">
                <div class="pb-2 pr-5 pl-4">
                  <mat-radio-group class="flex flex-col" aria-label="Select an option"
                    [(ngModel)]="currentItinerary.defaultTravelMode.mode" (change)="travelMode(travelModeMenuTrigger)"
                    igClickStopPropagation>
                    <mat-radio-button value="DRIVING">DRIVING</mat-radio-button>
                    <mat-radio-button value="BICYCLING" class="">CYCLING</mat-radio-button>
                    <mat-radio-button value="WALKING" class="">WALKING</mat-radio-button>
                  </mat-radio-group>
                </div>
              </mat-menu>
            </div>

            <div [class.!hidden]="isMobile && isFoldItineraryTitle"
              class="ig-iti-stop-list flex flex-col gap-6 p-[1vw] max-w-[650px] mobile:relative mobile:w-full mobile:max-w-[100%] mobile:!left-0 mobile:p-0">
              <div *ngIf="data.isEditMode">
                <ig-search-attractions *ngIf="currentItinerary" [existing]="currentItinerary.attractions"
                  [style]="currentItinerary.mapStyle" [hubName]="hubName" [searchFor]="'all'"
                  (addPlace)="addPlace($event)"></ig-search-attractions>
              </div>

              <div
                class="ig-iti-stop-container flex gap-3 w-full flex-col pl-10 justify-center transition-all duration-300 animate-left-in"
                [class.opacity-0]="isMovieSimulateTourShowing">
                <div class="flex justify-between items-center cursor-pointer rounded py-1 bg-[#00000088]"
                  [class.!bg-[#e6e6e67d]]="
                    currentItinerary.mapStyle === 'light' &&
                    !isAttractionsExpanded
                  " [class.!bg-[#f2f2f2d9]]="
                    currentItinerary.mapStyle === 'light' &&
                    isAttractionsExpanded
                  " [class.text-gray-600]="currentItinerary.mapStyle === 'light'" (click)="expandAttractions()">
                  <h2 class="text-[20px] pl-5 mobile:text-lg 3xl:text-[24px]" [class.ig-color-picker-shadow]="
                      currentItinerary.mapStyle === 'dark'
                    ">
                    {{ currentItinerary.attractions.length }}
                    ATTRACTIONS TO VISIT
                  </h2>
                  <mat-icon class="text-[30px] !h-[30px] mr-[1vw]" [class.ig-color-picker-shadow]="
                      currentItinerary.mapStyle === 'dark'
                    " [matTooltip]="
                      (isAttractionsExpanded ? 'Hide ' : 'Show ') +
                      'attraction details'
                    ">{{
                    isAttractionsExpanded ? "expand_more" : "chevron_left"
                    }}
                  </mat-icon>
                </div>

                <div
                  class="overflow-y-auto overflow-x-hidden bg-[#00000088] ig-iti-stop-items pr-4 mobile:!overflow-y-visible mobile:!max-h-fit"
                  [class.!bg-[#e6e6e67d]]="
                    currentItinerary.mapStyle === 'light' &&
                    !isAttractionsExpanded
                  " [class.!bg-[#f2f2f2d9]]="
                    currentItinerary.mapStyle === 'light' &&
                    isAttractionsExpanded
                  " [class.!max-h-[80vh]]="mode === 'embed'" (cdkDropListDropped)="dropAttraction($event)" cdkDropList>
                  <div class="flex gap-5 items-center px-1.5" [class.!px-[10px]]="isAttractionsExpanded">
                    <div
                      class="w-8 h-8 rounded-full bg-transparent border border-white flex items-center justify-center transition-all text-black font-bold group-hover:scale-[1.2] group-hover:bg-[gold]"
                      [class.border-gray-600]="
                        currentItinerary.mapStyle === 'light'
                      ">
                      <mat-icon class="!h-4 !w-4 text-white" [class.!text-gray-600]="
                          currentItinerary.mapStyle === 'light'
                        ">
                        room
                      </mat-icon>
                    </div>
                    <p class="text-[17px] font-semibold" [class.text-gray-600]="
                        currentItinerary.mapStyle === 'light'
                      ">
                      Start Itinerary
                    </p>
                  </div>

                  <div #attractioncard *ngFor="
                      let stop of currentItinerary.attractions;
                      let i = index
                    " cdkDrag class="rounded flex flex-col group select-none ig-rotate-180" (click)="showDetails(stop)"
                    [cdkDragDisabled]="isAttractionsExpanded" (cdkDragStarted)="isAttractionsExpanded = false"
                    [class.mb-1]="!isAttractionsExpanded" [class.bg-[#00000088]]="!isAttractionsExpanded"
                    [class.!bg-[#e6e6e67d]]="
                      currentItinerary.mapStyle === 'light' &&
                      !isAttractionsExpanded
                    " [ngStyle]="{ 'animation-delay': i * 0.1 + 's' }" (mouseenter)="hoverAttraction(stop)">
                    <div class="flex gap-6 w-full py-6 pl-3" [class.!py-1]="!isAttractionsExpanded">
                      <div class="border-gray-400 border-dashed -my-10 flex items-center"
                        [class.border-r]="isAttractionsExpanded">
                        <div
                          class="w-5 h-5 rounded-full bg-gray-300 -mr-[14px] flex items-center justify-center transition-all text-black font-bold group-hover:scale-[1.4] group-hover:bg-[gold]"
                          [class.w-7]="isAttractionsExpanded" [class.h-7]="isAttractionsExpanded">
                          {{ i + 1 }}
                        </div>
                      </div>

                      <div class="w-[calc(100%-58px)] text-[12px] relative">
                        <div *ngIf="stop.preDescription" [class.!opacity-0]="!isAttractionsExpanded"
                          [class.!h-0]="!isAttractionsExpanded" [class.!bg-[#e6e6e67d]]="
                            currentItinerary.mapStyle === 'light' &&
                            !isAttractionsExpanded
                          " [class.!bg-[#f2f2f2d9]]="
                            currentItinerary.mapStyle === 'light' &&
                            isAttractionsExpanded
                          " [class.text-gray-600]="
                            currentItinerary.mapStyle === 'light'
                          " [class.!mb-0]="!isAttractionsExpanded"
                          class="bg-[#00000088] rounded-md text-[14px] mb-4 transition-all duration-700 overflow-hidden">
                          {{ removeHtml(stop.preDescription) }}
                        </div>

                        <div class="relative border-gray-400 pl-4 cursor-pointer" [class.border-l-[1px]]="
                            (stop.preDescription || stop.postDescription) &&
                            isAttractionsExpanded
                          ">
                          <p class="text-[16px] font-semibold text-blue-500 mb-1 transition-all duration-700 overflow-hidden hover:scale-[1.02]"
                            [class.!w-0]="isAttractionsExpanded" [class.!h-0]="isAttractionsExpanded">
                            {{ stop.item.name }}
                          </p>

                          <div *ngIf="isAttractionsExpanded" class="flex gap-3 items-center">
                            <ig-attraction-editor *ngIf="data.isEditMode" class="-translate-y-1" [attraction]="stop"
                              [itinerary]="currentItinerary" [isJustAddedPlaces]="isJustAddedPlaces"
                              (descriptionChange)="
                                attractionDescriptionChanged($event, stop)
                              " (preDescriptionChange)="
                                stop.preDescription = $event;
                                isShowSaveAttractionChanges = true
                              " (postDescriptionChange)="
                                stop.postDescription = $event;
                                isShowSaveAttractionChanges = true
                              " (onRemove)="removeAttraction($event)" (onMapIconSelected)="updateMapIcons()"
                              igClickStopPropagation></ig-attraction-editor>
                            <p class="font-semibold text-[16px] text-blue-500 !mb-2">
                              {{ stop.item.name }}
                            </p>
                          </div>

                          <ig-image [src]="stop.item.cover?.source"
                            class="w-0 min-w-0 max-w-0 h-0 min-h-0 transition-all duration-700 block"
                            cls="object-cover rounded-lg h-full" [class.ig-iti-stop-img-show-mode2]="
                              isAttractionsExpanded
                            "></ig-image>

                          <p *ngIf="stop.item.rating && isAttractionsExpanded"
                            class="absolute right-2 top-10 z-10 flex items-center text-[12px] text-white rounded-xl py-0.5 px-1.5 bg-black overflow-hidden transition-all duration-700"
                            [class.!text-gray-800]="
                              currentItinerary.mapStyle === 'light'
                            " [class.font-semibold]="
                              currentItinerary.mapStyle === 'light'
                            " [class.bg-white]="
                              currentItinerary.mapStyle === 'light'
                            ">
                            <mat-icon class="!w-4 !h-3">star</mat-icon>
                            {{ stop.item.rating }}
                          </p>

                          <div *ngIf="isAttractionsExpanded" class="rounded-md transition-all duration-700"
                            [class.text-gray-600]="
                              currentItinerary.mapStyle === 'light'
                            ">
                            <p *ngIf="stop.item['timeOneLine']" class="!mt-1 flex items-center gap-2">
                              <mat-icon class="!w-3 !h-3">scheduler</mat-icon>
                              <span class="mobile:text-sm">{{
                                stop.item['timeOneLine']
                                }}</span>
                            </p>
                            <p *ngIf="stop.item['categoryText']" class="!mt-1 flex items-center gap-2">
                              <mat-icon class="!w-3 !h-3">list</mat-icon>
                              <span class="mobile:text-sm">{{
                                stop.item['categoryText']
                                }}</span>
                            </p>
                            <p class="!mt-1 flex items-center gap-2">
                              <mat-icon class="!w-3 !h-3">room</mat-icon>
                              {{ stop.item.address.address }}
                            </p>
                            <p class="!mt-2">
                              {{ removeHtml(stop.item.description) }}
                            </p>
                          </div>
                        </div>

                        <div *ngIf="stop.postDescription" [class.!opacity-0]="!isAttractionsExpanded"
                          [class.!h-0]="!isAttractionsExpanded" [class.!mt-0]="!isAttractionsExpanded"
                          [class.!bg-[#e6e6e67d]]="
                            currentItinerary.mapStyle === 'light' &&
                            !isAttractionsExpanded
                          " [class.!bg-[#f2f2f2d9]]="
                            currentItinerary.mapStyle === 'light' &&
                            isAttractionsExpanded
                          " [class.text-gray-600]="
                            currentItinerary.mapStyle === 'light'
                          "
                          class="bg-[#00000088] rounded-md mt-4 text-[14px] transition-all duration-700 overflow-hidden">
                          {{ removeHtml(stop.postDescription) }}
                        </div>
                      </div>
                    </div>

                    <div *ngIf="
                        isAttractionsExpanded &&
                        directionResults?.routes[0]?.legs[i]
                      " class="flex justify-center mt-1">
                      <div
                        class="text-gray-200 bg-black translate-x-5 rounded-xl px-2 py-0.5 text-center text-[12px] border border-gray-600"
                        [class.!bg-white]="
                          currentItinerary.mapStyle === 'light'
                        " [class.!text-black]="
                          currentItinerary.mapStyle === 'light'
                        ">
                        --
                        <mat-icon class="!w-3 !h-3 text-[12px] translate-y-[1px]">{{
                          currentItinerary.defaultTravelMode.mode ===
                          "WALKING"
                          ? "directions_walk"
                          : currentItinerary.defaultTravelMode.mode ===
                          "BICYCLING"
                          ? "directions_bike"
                          : "directions_car"
                          }}
                        </mat-icon>
                        {{ directionResults.routes[0].legs[i].distance.text }}
                        ,
                        {{
                        directionResults?.routes[0]?.legs[i].duration.text
                        }}
                        --
                      </div>
                    </div>
                  </div>

                  <div class="text-center mt-6 flex justify-center italic ig-color-picker-shadow">
                    -- End of itinerary --
                  </div>
                </div>

                <div *ngIf="isShowSaveAttractionChanges" class="w-full flex justify-center">
                  <ig-button class="mt-4 w-fit" successText="Attraction changes saved" [isAsync]="true"
                    (trigger)="saveDescriptions($event)">
                    Save attraction changes
                  </ig-button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div #mapContainer class="ig-iti-map-container h-full w-full pt-16 pb-10 relative animate-right-in">
          <div class="absolute top-0 w-full left-0 h-0 bg-black z-50 transition-all duration-700"
            [class.!h-[15%]]="isMovieSimulateTourShowing && !isMobile"></div>
          <div class="absolute bottom-0 w-full left-0 h-0 bg-black z-50 transition-all duration-700"
            [class.!h-[15%]]="isMovieSimulateTourShowing && !isMobile"></div>

          <ig-tour-movie-simulation #movieSimulator [currentItinerary]="currentItinerary" [googleMap]="googleMap"
            [directionResults]="directionResults" [directionLines]="directionLines"
            [mapStyle]="currentItinerary.mapStyle" (onStart)="movie360Start()"
            (onEnd)="movie360End()"></ig-tour-movie-simulation>

          <div class="absolute bottom-10 left-0 w-full h-fit bg-transparent flex z-20"
            [class.ig-hide]="!isNavigationShowing">
            <div class="w-[30%] max-w-[650px] mobile:hidden"></div>
            <ig-direction-navigation class="block flex-grow" [map]="googleMap" [currentItinerary]="currentItinerary"
              [directionResults]="directionResults" [travelMode]="currentItinerary.defaultTravelMode.mode"
              [mode]="currentItinerary.mapStyle" (onExit)="isNavigationShowing = false">
            </ig-direction-navigation>
          </div>

          <ig-google-map #map class="h-full w-full transition-all" [markers]="mapMarkers"
            [mode]="currentItinerary.mapStyle" [class.ig-iti-map-tour-mobile]="
              isMovieSimulateTourShowing && isMobile
            " [useDefaultMarkerClickStyle]="false" (onMarkerClick)="markerClick($event)"></ig-google-map>

          <div *ngIf="isMovieSimulateTourShowing" #mapmask [class.ig-iti-map-tour-mobile]="isMobile"
            [class.z-50]="isMobile" class="w-full h-full absolute top-0 left-0 z-10 transition-all duration-700">
            <div class="bg-transparent w-full h-full"></div>
          </div>
        </div>
        }
      </div>
    </div>
  </div>
  } @if (tempDetailsStyle === 'story' || currentItinerary.detailsStyle === 'story') {
  <div
    class="w-full h-full absolute z-10 top-0 left-0 text-gray-200 overflow-auto ig-iti-story-telling mobile:p-4"
    [class.!text-gray-600]="currentItinerary.mapStyle === 'light'"
    [class.!bg-white]="currentItinerary.mapStyle === 'light' && !hideTitle"
    [class.scrollbar-bg-light]="currentItinerary.mapStyle === 'light'"
    [class.scrollbar-bg-dark]="currentItinerary.mapStyle !== 'light'"
    [class.bg-gray-950]="!hideTitle">
    <div id="ig-iti-story-wrap"
      class="w-[80vw] max-w-[1380px] flex flex-col items-start mx-auto mobile:w-full mobile:pt-[2vh]"
      [class.pt-[5vh]]="!hideTitle">
      <div class="flex gap-4" [class.hidden]="hideTitle">
        <b class="text-[26px] mb-[4vh] text-blue-500 2xl:text-[30px] 3xl:text-[36px] d">{{ currentItinerary.title }}</b>
        <ig-create-itinerary *ngIf="data.isEditMode" [itinerary]="currentItinerary"
          (onCreateItinerary)="itineraryUpdated($event)" triggerText="" igClickStopPropagation></ig-create-itinerary>
      </div>
      <ig-image [src]="currentItinerary.image" class="w-full mx-auto mobile:h-auto"
        cls="w-full h-full object-cover rounded-lg mobile:h-auto"></ig-image>

      <div
        class="flex gap-6 mt-7 items-center justify-center w-full transition-all duration-700 text-gray-200 ig-itinerary-data mobile:flex-wrap mobile:gap-2 mobile:justify-start"
        [class.!text-gray-600]="currentItinerary.mapStyle === 'light'">
        <p
          class="text-center pl-2 border-l-2 border-gray-400 flex items-center gap-1 text-[16px] 2xl:text-[18px] 3xl:text-[18px] mobile:text-[14px]">
          <mat-icon class="text-[30px] !w-8 !h-8 mobile:text-[20px] mobile:!w-5 mobile:!h-5">room
          </mat-icon>
          {{ currentItinerary.attractions.length }} stops
        </p>
        <p
          class="text-center pl-2 border-l-2 border-gray-400 flex items-center gap-1 text-[16px] 2xl:text-[18px] 3xl:text-[18px] mobile:text-[14px] mobile:h-5">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="32px"
            height="32px" viewBox="0,0,256,256" class="mobile:scale-[0.6]">
            <g fill="#fff" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
              stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
              font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"
              [class.!stroke-black]="currentItinerary.mapStyle === 'light'">
              <g transform="scale(10.66667,10.66667)">
                <path
                  d="M2,6c0,-2.209 1.791,-4 4,-4c2.209,0 4,1.791 4,4c0,1.782 -2.032,4.326 -3.2,5.64c-0.426,0.479 -1.176,0.479 -1.601,0c-1.167,-1.313 -3.199,-3.858 -3.199,-5.64z"
                  opacity="0.35"></path>
                <circle cx="6" cy="6" r="1.5"></circle>
                <path
                  d="M14,16c0,-2.209 1.791,-4 4,-4c2.209,0 4,1.791 4,4c0,1.782 -2.032,4.326 -3.2,5.64c-0.426,0.479 -1.176,0.479 -1.601,0c-1.167,-1.313 -3.199,-3.858 -3.199,-5.64z"
                  opacity="0.35"></path>
                <circle cx="18" cy="16" r="1.5"></circle>
                <circle cx="6" cy="15" r="1"></circle>
                <circle cx="9" cy="19" r="1"></circle>
                <circle cx="14" cy="21" r="1"></circle>
              </g>
            </g>
          </svg>
          {{
          tripService.convertToTravelDistance(currentItinerary.distance).all
          }}
        </p>
        <p
          class="text-center pl-2 border-l-2 border-gray-400 flex items-center gap-1 text-[16px] 2xl:text-[18px] 3xl:text-[18px] mobile:text-[14px]">
          <mat-icon class="text-[30px] !w-8 !h-8 mobile:text-[20px] mobile:!w-5 mobile:!h-5">schedule
          </mat-icon>
          {{ tripService.convertToTravelTimeText(currentItinerary.travelTime) }}
        </p>
        <!--            <p class="text-center pl-2 flex items-center gap-1 2xl:text-[18px] 3xl:text-[18px]">-->
        <!--              <mat-icon class="text-[30px] !w-8 !h-8">event</mat-icon>-->
        <!--              Suggested days: 3-->
        <!--            </p>-->
        @for (field of currentItinerary.customFields; let i = $index; track i) {
        <p
          class="text-center border-l-2 border-gray-400 flex items-center gap-1 pl-4 text-[16px] 2xl:text-[18px] 3xl:text-[18px] mobile:text-[14px]">
          {{ field.field }}
        </p>
        }
      </div>

      <div
        class="flex gap-4 justify-center w-full text-sm text-center transition-all duration-500 text-white my-8 ig-itinerary-operation mobile:justify-start mobile:flex-wrap mobile:mt-6"
        [class.!text-gray-600]="currentItinerary.mapStyle === 'light'">
        <div
          class="px-4 py-2 border border-gray-300 outline outline-0 outline-offset-1 transition-all rounded-sm flex items-center justify-center cursor-pointer smallDesktop:text-[12px] hover:bg-[#ffffff66]"
          [class.!outline-1]="currentItinerary.mapStyle === 'light'" (click)="exportPDF()">
          <span *ngIf="!isGeneratingPDF">EXPORT AS PDF</span>
          <ig-spinner *ngIf="isGeneratingPDF" [diameter]="20"></ig-spinner>
        </div>
        <div
          class="px-4 py-2 border border-gray-300 outline outline-0 outline-offset-1 transition-all rounded-sm flex items-center justify-center cursor-pointer smallDesktop:text-[12px] hover:bg-[#ffffff66]"
          [class.!outline-1]="currentItinerary.mapStyle === 'light'" (click)="shareItinerary()">
          SHARE ITINERARY
        </div>
        <div
          class="px-4 py-2 border border-gray-300 outline outline-0 outline-offset-1 transition-all rounded-sm flex items-center justify-center cursor-pointer smallDesktop:text-[12px] hover:bg-[#ffffff66]"
          [class.!outline-1]="currentItinerary.mapStyle === 'light'" (click)="movie360()">
          VIRTUAL TOUR
        </div>

        <div
          class="px-4 py-2 relative border border-gray-300 outline outline-0 outline-offset-1 transition-all rounded-sm flex items-center justify-center cursor-pointer smallDesktop:text-[11px] hover:bg-[#ffffff66]"
          [class.!outline-1]="currentItinerary.mapStyle === 'light'" (click)="isShowGPSConfirm=true" igOutsideClick
          (outsideClick)="isShowGPSConfirm = false" igClickStopPropagation>
          GPS DIRECTIONS

          <ig-confirm-dialog *ngIf="isShowGPSConfirm"
            class="!w-[300px] -right-20 bottom-4 absolute mobile:!w-[191px] mobile:-right-16"
            (confirm)="gpsDirections()" (cancel)="directions()" [isShowIcon]="false" igClickStopPropagation
            text="Do you want to start this itinerary from your current location?">
          </ig-confirm-dialog>
        </div>
        <div
          class="px-4 py-2 border border-gray-300 outline outline-0 outline-offset-1 transition-all rounded-sm flex items-center justify-center cursor-pointer smallDesktop:text-[11px] hover:bg-[#ffffff66]"
          [class.!outline-1]="currentItinerary.mapStyle === 'light'" #travelModeMenuTrigger="matMenuTrigger"
          [matMenuTriggerFor]="travelModeMenu" [class.ig-hide]="!currentItinerary.defaultTravelMode.canChange">
          TRAVEL MODE
        </div>
        <mat-menu #travelModeMenu="matMenu" class="ig-iti-details-style-menu">
          <div class="pb-2 pr-5 pl-4">
            <mat-radio-group class="flex flex-col" aria-label="Select an option"
              [(ngModel)]="currentItinerary.defaultTravelMode.mode" (change)="travelMode(travelModeMenuTrigger)"
              igClickStopPropagation>
              <mat-radio-button value="DRIVING">DRIVING</mat-radio-button>
              <mat-radio-button value="BICYCLING" class="">CYCLING</mat-radio-button>
              <mat-radio-button value="WALKING" class="">WALKING</mat-radio-button>
            </mat-radio-group>
          </div>
        </mat-menu>
      </div>

      <p class="text-[15px] my-6 text-center w-full mobile:mt-6 mobile:mb-0">
        {{ currentItinerary.description }}
      </p>

      <div #storyMapWrap id="ig-iti-story-map-wrap" class="relative w-full h-full mb-14 pt-6">
        <div class="relative">
          <ig-tour-movie-simulation #movieSimulator [currentItinerary]="currentItinerary" mode="story"
            [googleMap]="googleMap" [directionResults]="directionResults" [directionLines]="directionLines"
            [mapStyle]="currentItinerary.mapStyle" (onStart)="movie360Start()"
            (onEnd)="movie360End()"></ig-tour-movie-simulation>

          <div class="absolute bottom-10 left-0 w-full h-fit bg-transparent flex z-20"
            [class.ig-hide]="!isNavigationShowing">
            <ig-direction-navigation class="block flex-grow" [map]="googleMap" [currentItinerary]="currentItinerary"
              [directionResults]="directionResults" [travelMode]="currentItinerary.defaultTravelMode.mode"
              [mode]="currentItinerary.mapStyle" (onExit)="isNavigationShowing = false">
            </ig-direction-navigation>
          </div>

          <ig-google-map class="h-[580px] w-full transition-all" [markers]="mapMarkers"
            [mode]="currentItinerary.mapStyle" [class.ig-iti-map-tour-mobile]="
              isMovieSimulateTourShowing && isMobile
            " [useDefaultMarkerClickStyle]="false" (onMarkerClick)="markerClick($event)"></ig-google-map>
        </div>

        <div *ngIf="isMovieSimulateTourShowing" #mapmask [class.ig-iti-map-tour-mobile]="isMobile"
          [class.z-50]="isMobile" class="w-full h-full absolute top-0 left-0 z-10 transition-all duration-700">
          <div class="bg-transparent w-full h-full"></div>
        </div>
      </div>

      <ig-search-attractions *ngIf="currentItinerary && data.isEditMode" [existing]="currentItinerary.attractions"
        [style]="currentItinerary.mapStyle" [hubName]="hubName" [searchFor]="'all'" class="w-[35%] min-w-[300px] mb-3"
        (addPlace)="addPlace($event)"></ig-search-attractions>

      <div class="flex w-full gap-4 items-center mb-6 px-1.5" [class.!mb-4]="!isAttractionsExpanded">
        <div
          class="w-8 h-8 rounded-full bg-transparent border border-white flex items-center justify-center -translate-x-0.5 transition-all text-black font-bold"
          [class.!border-gray-600]="currentItinerary.mapStyle === 'light'">
          <mat-icon class="!h-4 !w-4 text-white" [class.!text-gray-600]="currentItinerary.mapStyle === 'light'">room
          </mat-icon>
        </div>

        <p class="text-[24px] font-semibold" [class.text-gray-600]="currentItinerary.mapStyle === 'light'">
          Start Itinerary
        </p>
        <mat-icon class="text-[30px] !h-[30px] mr-[1vw] cursor-pointer" (click)="expandAttractions()"
          [class.ig-color-picker-shadow]="currentItinerary.mapStyle === 'dark'" [matTooltip]="
            (isAttractionsExpanded ? 'Hide ' : 'Show ') + 'attraction details'
          ">{{ isAttractionsExpanded ? "expand_more" : "chevron_left" }}
        </mat-icon>
      </div>

      <div (cdkDropListDropped)="dropAttraction($event)" cdkDropList>
        <div *ngFor="let stop of currentItinerary.attractions; let i = index" cdkDrag
          [cdkDragDisabled]="isAttractionsExpanded" class="w-full mb-10 flex pl-5 group relative"
          [class.!mb-5]="!isAttractionsExpanded" [class.cursor-pointer]="!isAttractionsExpanded"
          [class.select-none]="!isAttractionsExpanded">
          <ig-attraction-editor *ngIf="data.isEditMode && isAttractionsExpanded" class="absolute top-0 z-50 right-1"
            [itinerary]="currentItinerary" [attraction]="stop" [isJustAddedPlaces]="isJustAddedPlaces"
            (descriptionChange)="attractionDescriptionChanged($event, stop)" (preDescriptionChange)="
              stop.preDescription = $event; isShowSaveAttractionChanges = true
            " (postDescriptionChange)="
              stop.postDescription = $event; isShowSaveAttractionChanges = true
            " (onRemove)="removeAttraction($event)" (onMapIconSelected)="updateMapIcons()"
            igClickStopPropagation></ig-attraction-editor>

          <div class="border-gray-400 border-dashed border-l-[1px] -my-5 flex items-center">
            <div
              class="w-8 h-8 rounded-full bg-gray-300 -translate-x-4 flex items-center justify-center transition-all text-black font-bold group-hover:scale-[1.3] group-hover:bg-[gold]">
              {{ i + 1 }}
            </div>
          </div>

          <div *ngIf="!isAttractionsExpanded" (click)="showDetails(stop)">
            <b class="text-blue-500 text-[18px] mb-1 cursor-pointer">
              {{ stop.item.name }}
            </b>
          </div>

          <div *ngIf="isAttractionsExpanded" class="w-full">
            <p *ngIf="stop.preDescription" class="mb-3 text-[15px] px-[8vw] mobile:pr-4 mobile:pl-0">
              {{ stop.preDescription }}
            </p>
            <div
              class="flex gap-10 items-center justify-between w-full px-[8vw] py-9 ig-iti-story-telling-place-info mobile:pl-0 mobile:pr-4 mobile:py-4 mobile:flex-col-reverse mobile:gap-2 mobile:items-start"
              [class.flex-row-reverse]="i % 2 === 1 && !isMobile" [class.ig-iti-story-telling-special-card]="
                i && (i + 1) % 3 === 0 && !isMobile
              ">
              <div>
                <b class="text-blue-500 text-[18px] mb-1 cursor-pointer" (click)="showDetails(stop)">
                  {{ stop.item.name }}
                </b>
                <p *ngIf="stop.item['rating']">
                  <mat-icon>star</mat-icon>
                  <span class="mobile:text-sm">{{ stop.item['rating'] }}</span>
                </p>
                <p *ngIf="stop.item['timeOneLine']">
                  <mat-icon>scheduler</mat-icon>
                  <span class="mobile:text-sm">{{
                    stop.item['timeOneLine']
                    }}</span>
                </p>
                <p *ngIf="stop.item['categoryText']">
                  <mat-icon>list</mat-icon>
                  <span class="mobile:text-sm">{{
                    stop.item['categoryText']
                    }}</span>
                </p>
                <p>
                  <mat-icon>room</mat-icon>
                  <span class="mobile:text-sm">{{
                    stop.item.address.address
                    }}</span>
                </p>
                <p class="text-[13px] mt-2 mobile:text-[15px]">
                  {{ removeHtml(stop.item.description) }}
                </p>
              </div>
              <div class="relative w-[45%] h-[250px] min-w-[45%] ig-iti-story-telling-img mobile:w-full">
                <ig-image class="w-full h-full" cls="rounded-xl h-full" [src]="stop.item.cover?.source"></ig-image>

                <p *ngIf="stop.item.rating"
                  class="absolute right-2 top-2 z-10 flex items-center !gap-1 text-[12px] text-white rounded-xl py-0.5 px-1.5 bg-black overflow-hidden transition-all duration-700"
                  [class.!text-gray-800]="currentItinerary.mapStyle === 'light'"
                  [class.font-semibold]="currentItinerary.mapStyle === 'light'"
                  [class.bg-white]="currentItinerary.mapStyle === 'light'">
                  <mat-icon class="!w-4 !h-3.5">star</mat-icon>
                  {{ stop.item.rating }}
                </p>
              </div>
            </div>
            <p *ngIf="stop.postDescription" class="mt-3 text-[15px] px-[8vw] mobile:pr-4 mobile:pl-0">
              {{ stop.postDescription }}
            </p>

            <div *ngIf="directionResults?.routes[0]?.legs[i]"
              class="text-gray-200 bg-black rounded-xl px-2 py-0.5 text-center text-[14px] max-w-[260px] border border-gray-600 w-full mx-auto mt-12 mb-4 mobile:mt-11 mobile:mb-2"
              [class.!bg-white]="currentItinerary.mapStyle === 'light'"
              [class.!text-black]="currentItinerary.mapStyle === 'light'">
              --
              <mat-icon class="!w-3.5 !h-3.5 text-[14px] translate-y-[1px]">{{
                currentItinerary.defaultTravelMode.mode === "WALKING"
                ? "directions_walk"
                : currentItinerary.defaultTravelMode.mode === "BICYCLING"
                ? "directions_bike"
                : "directions_car"
                }}
              </mat-icon>
              {{ directionResults.routes[0].legs[i]?.distance?.text }}
              , {{ directionResults?.routes[0]?.legs[i]?.duration?.text }} --
            </div>
          </div>
        </div>
      </div>

      <div class="flex w-full gap-4 items-center mb-12 px-1.5 -translate-y-4 mobile:mb-0"
        [class.!translate-y-0]="!isAttractionsExpanded">
        <div
          class="w-8 h-8 rounded-full bg-transparent border border-white flex items-center justify-center -translate-x-0.5 transition-all text-black font-bold"
          [class.!border-gray-600]="currentItinerary.mapStyle === 'light'">
          <mat-icon class="!h-4 !w-4 text-white" [class.!text-gray-600]="currentItinerary.mapStyle === 'light'">album
          </mat-icon>
        </div>
        <p class="text-[24px] font-semibold" [class.text-gray-600]="currentItinerary.mapStyle === 'light'">
          End of Itinerary
        </p>
      </div>

      <ig-powered-by [style]="'iti-horizontal'" class="mt-6 mb-12 mx-auto flex justify-center"></ig-powered-by>

      <div *ngIf="isShowSaveAttractionChanges && data.isEditMode"
        class="w-full flex justify-center fixed bottom-12 left-0">
        <ig-button class="mt-4 w-fit h-12" cls="h-12" successText="Attraction changes saved" [isAsync]="true"
          (trigger)="saveDescriptions($event)">
          Save attraction changes
        </ig-button>
      </div>
    </div>
  </div>

  } @if (!tempDetailsStyle && currentItinerary.detailsStyle === 'map3d') {
  <div
    class="flex w-full h-full rounded-3xl absolute z-10 top-0 left-0 bg-[#00000088] text-gray-200 transition-all animate-bottom-up"
    [class.ig-iti-white-map]="currentItinerary.mapStyle === 'light'">
    <iframe #virtual3DIframe [src]="virtual3DSrcSafe"
      class="absolute z-10 top-0 left-0 w-full h-full rounded-2xl"></iframe>

    @if (is3DMapLoaded) {
    <div class="absolute z-20 left-5 top-4">
      <ig-create-itinerary *ngIf="data.isEditMode" [itinerary]="currentItinerary"
        (onCreateItinerary)="itineraryUpdated($event)" triggerText="" igClickStopPropagation></ig-create-itinerary>
    </div>

    <div class="absolute z-20 left-5 top-[17rem] w-[calc(400px-40px)]" [class.opacity-0]="isHideSearchBarFor3DMap">
      <ig-search-attractions *ngIf="currentItinerary && data.isEditMode" [existing]="currentItinerary.attractions"
        [style]="'light'" [hubName]="hubName" [searchFor]="'all'" class="w-[35%] min-w-[300px] mb-3"
        (addPlace)="addPlace($event)"></ig-search-attractions>
    </div>

    <div *ngIf="isShowSaveAttractionChanges"
      class="absolute z-20 bottom-6 left-5 w-[calc(400px-40px)] flex justify-center">
      <ig-button class="mt-4 w-fit" successText="Attraction changes saved" [isAsync]="true"
        (trigger)="saveDescriptions($event)">
        Save attraction changes
      </ig-button>
    </div>

    <div class="absolute bottom-10 left-0 w-full h-fit bg-transparent flex -z-20">
      <ig-direction-navigation class="block flex-grow" [map]="googleMap" [currentItinerary]="currentItinerary"
        [directionResults]="directionResults" [travelMode]="currentItinerary.defaultTravelMode.mode"
        [mode]="currentItinerary.mapStyle" (onExit)="isNavigationShowing = false">
      </ig-direction-navigation>
    </div>
    }
  </div>

  <!-- <div *ngIf="data.isEditMode && !isMovieSimulateTourShowing"
    class="w-[90vw] max-w-[2000px] bg-[transparent] absolute top-0 z-[3000]">
    <ig-itinerary-details-style-editor [textColor]="
      currentItinerary.mapStyle === 'light' ? '#52525b' : '#e5e7eb'
    " class="flex gap-2 items-center absolute top-2 right-[36px] z-[100]" (styleChange)="detailsStyleChanged($event)"
      [currentItinerary]="currentItinerary"></ig-itinerary-details-style-editor>

    <ig-map-style-selector class="absolute top-2 right-[300px] z-20" [textColor]="
      currentItinerary.mapStyle === 'light' ? '#52525b' : '#e5e7eb'
    " [style]="currentItinerary.mapStyle" [currentItinerary]="currentItinerary"
      triggerText="Theme mode"></ig-map-style-selector>
  </div> -->
  } }
</div>